module.exports = __webpack_public_path__ + "assets/images/warn-chart-icon-16.png";


//////////////////
// WEBPACK FOOTER
// ./app/components/sensors-and-connectors/components/thing-chart/warn-chart-icon-16.png
// module id = 3FGJ
// module chunks = 1